import type { FC } from 'react';
import { Icon, type IconProps } from '@/components/Icon';
import type { Language } from '@/utils/language';

/** Один язык выбора: код, флаг и ключ подписи с пространством имён (common:…) */
export interface LanguageOption {
	code: Language;
	Flag: FC<IconProps>;
	labelKey: string;
}

/**
 * Подписи хранятся ключами, а не готовым текстом: вызов t() в теле модуля
 * выполнился бы один раз до всякой смены языка. Тот же приём уже применён
 * в NAV_ITEMS шапки.
 *
 * Значения этих ключей совпадают в обоих словарях намеренно: каждый язык
 * назван на себе самом. Иначе человек, попавший на русский интерфейс и
 * языка не знающий, увидел бы пункт «Английский» — подсказку на том
 * языке, из которого он пытается выйти.
 */
export const LANGUAGES: readonly LanguageOption[] = [
	{ code: 'ru', Flag: Icon.FlagRu, labelKey: 'common:language.ru' },
	{ code: 'en', Flag: Icon.FlagEn, labelKey: 'common:language.en' },
];
